import React, { useEffect, useMemo, useState } from 'react'
import {
  Grid,
  useMediaQuery,
  useTheme,
  Container,
  Typography,
} from '@material-ui/core'
import { connect } from 'react-redux'
import Layout from '../components/Layout/Layout'
import { useRouter } from 'next/router'
import Button from '../components/Button/Button'
import { deleteUser, getUser, logoutUser } from '../redux/actions/user'
import dayjs from 'dayjs'
import clsx from 'clsx'
import Loader from '../components/Loader/Loader'
import OrderList from '../components/Order/OrderList'
import SubscriptionList from '../components/Subscription/SubscriptionList'
import TakeBackList from '../components/TakeBack/TakeBackList'
import SwiperModal from '../components/SwiperModal/SwiperModal'
import { getTranslations } from '../i18n'
import { useTranslation } from 'react-i18next'
import { numberToPrice, setFullLocale, downloadInvoice } from '../utils/utils'
import { useMatomo } from '@datapunt/matomo-tracker-react'
import { postProductToReturn } from '../redux/actions/order'
import { getAddress, patchAddress } from '../redux/actions/addressUser'
const customParseFormat = require('dayjs/plugin/customParseFormat')
import Warning from '@material-ui/icons/Warning'
import CMSText, { prismicText } from '../components/Global/CMSText'
import {
  getInProgressContractCSUB,
  getInProgressContractSUB,
} from '../redux/actions/contract'
import { putUserOrder, getUserOrders } from '../redux/actions/user'
import { getOrderInvoice } from '../redux/actions/order'
import {
  getUserTakeBackProducts,
  getRightOfWithdrawalInfo,
} from '../redux/actions/takeBack'
dayjs.extend(customParseFormat)
import TakeBackOrderList from '../components/TakeBack/TakeBackOrderList'
import {
  SSOCulturaLogout,
  SSODecathlonLogout,
  SSOVirginLogout,
} from '../components/UserForm/SSOLogout'
import Link from '../components/Link/Link'
import { isSecondHandOnly, LOCAL_STORAGE_KEYS } from '../utils/constants'
import SecondHandAndRentalOrderList from '../components/Order/SecondHandAndRentalOrderList'
import { createClient, getSingleDocument } from '../prismicio'
import { RootState } from '../redux/reducers/rootReducer'
import { InferGetStaticPropsType } from 'next/types'
import { GetMapDispatchTypes } from '../interfaces/common/redux'
import { AccountFaq } from '../components/Account/AccountFaq'
import { useAccountStyles } from '../components/Account/AccountStyles'
import { InfoLink } from '../components/Account/InfoLink'
import { NoOrderBox } from '../components/Account/NoOrderBox'
import { PrismicAccount } from '../interfaces/common/prismicAccount'
import { useCart } from '@/hooks/useCart'

type Tprops = ReturnType<typeof mapStateToProps> &
  InferGetStaticPropsType<typeof getStaticProps> &
  GetMapDispatchTypes<typeof mapDispatchToProps>

const mapStateToProps = (state: RootState) => ({
  user: state.user,
  cart: state.cart,
  parameters: state.parameters,
  addressUser: state.addressUser,
  contract: state.contract,
  userTakeBackProducts: state.takeBack,
  stores: state.stores,
  SSOdata: state.SSOdata,
})

const mapDispatchToProps = {
  postProductToReturn: postProductToReturn,
  deleteUser: deleteUser,
  getAddress: getAddress,
  patchAddress: patchAddress,
  getUser: getUser,
  logoutUser: logoutUser,
  getInProgressContractCSUB: getInProgressContractCSUB,
  getInProgressContractSUB: getInProgressContractSUB,
  putUserOrder: putUserOrder,
  getUserOrders: getUserOrders,
  getUserTakeBackProducts: getUserTakeBackProducts,
  getRightOfWithdrawalInfo: getRightOfWithdrawalInfo,
  getOrderInvoice: getOrderInvoice,
}

const Account = ({
  main,
  user,
  faqRes,
  parameters,
  postProductToReturn,
  getInProgressContractCSUB,
  getInProgressContractSUB,
  inStoreText,
  customer_survey,
  doc,
  sub_list,
  getAddress,
  patchAddress,
  addressUser,
  getUser,
  contract,
  putUserOrder,
  getUserOrders,
  basket,
  getUserTakeBackProducts,
  getRightOfWithdrawalInfo,
  takeback,
  userTakeBackProducts,
  stores,
  SSOdata,
  getOrderInvoice,
  logoutUser,
  banner,
}: Tprops) => {
  const classes = useAccountStyles()
  const router = useRouter()
  const theme = useTheme()
  const { emptyCart } = useCart()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const [modalHowItWorks, setModalHowItWorks] = useState(false)
  const [modalRemoveItem, setModalRemoveItem] = useState(false)
  const [invoiceDownloadError, setInvoiceDownloadError] = useState(false)
  const [checkUser, setCheckUser] = useState(false)
  const { t } = useTranslation()
  const { trackPageView, trackEvent } = useMatomo()
  const isSecondHand = parameters?.items?.enableTakeBack
  const isSubscription =
    process.env.STORE_TYPE === 'subscription' ||
    process.env.STORE_TYPE === 'classic_subscription'

  const likingEnabled = main?.data?.wishlist_enabled
  const token =
    typeof localStorage !== 'undefined'
      ? localStorage.getItem(LOCAL_STORAGE_KEYS.TOKEN)
      : 'undefined'

  useEffect(() => {
    trackPageView({ documentTitle: 'Account' })
  }, [])

  useEffect(() => {
    if (user?.user) {
      searchContract()
      getUserTakeBackProducts({ email: user?.user?.email })
    }
    if (!user?.orders || user?.orders?.length === 0) getUserOrders()
  }, [user?.user])

  const searchContract = async () => {
    if (process.env.STORE_TYPE === 'classic_subscription') {
      const contract = await getInProgressContractCSUB('in_progress')
      if (
        contract.type === 'GET_IN_PROGRESS_CONTRACT_SUB_FAILURE' ||
        contract?.currentContract?.length === 0
      ) {
        await getInProgressContractCSUB('in_coming')
      }
    } else if (process.env.STORE_TYPE === 'subscription') {
      const contract = await getInProgressContractSUB('in_progress')
      if (
        contract.type === 'GET_IN_PROGRESS_CONTRACT_SUB_FAILURE' ||
        contract?.currentContract?.length === 0
      ) {
        await getInProgressContractSUB('in_coming')
      }
    }
  }

  useEffect(() => {
    if (token && !user?.user) {
      const isAsync = async () => {
        await getUser()
      }
      isAsync()
    }
  }, [])

  useEffect(() => {
    if (!user.loading && !user.isLoggedIn) {
      router.push('/register')
      setCheckUser(false)
    } else setCheckUser(true)
  }, [user?.isLoggedIn])

  useEffect(() => {
    // Check if user as a default address
    if (user?.user?.address && Object.keys(user?.user?.address).length === 0) {
      setCheckUser(false)
      const isAsync = async () => {
        // If not get address
        const response = await getAddress()
        if (response.type === 'GET_ADDRESS_USER_SUCCESS') {
          setCheckUser(true)
        }
      }
      isAsync()
    }
  }, [user?.user?.address])

  useEffect(() => {
    // If address are available get the first one and set to default address in user state
    const isAsync = async () => {
      setCheckUser(false)
      if (
        user?.user?.address &&
        Object.keys(user?.user?.address).length === 0 &&
        addressUser?.items?.length > 0
      ) {
        const defaultAddressId = addressUser.items[0].id
        const response = await patchAddress(defaultAddressId)
        if (response.type === 'PATCH_ADDRESS_USER_SUCCESS') {
          // Once patch is done update user state
          await getUser()
        }
        setCheckUser(true)
      } else {
        setCheckUser(true)
      }
    }
    isAsync()
  }, [addressUser])

  const logOut = () => {
    const userType = localStorage.getItem(LOCAL_STORAGE_KEYS.USER_TYPE)
    const connexionType = localStorage.getItem(
      LOCAL_STORAGE_KEYS.CONNEXION_TYPE
    )
    const store = process.env.STORE
    const isDecathlonUser = connexionType === 'decathlon' && userType === 'SSO'
    const isCulturaUser = store === 'cultura' && userType === 'SSO'
    const isVirginUser = store === 'virgin' && userType === 'SSO'
    if (isCulturaUser) {
      const SSOIdToken = SSOdata?.items?.id_token
      SSOCulturaLogout(SSOIdToken, trackEvent, router)
    }
    if (isDecathlonUser) {
      const SSOIdToken = localStorage.getItem(LOCAL_STORAGE_KEYS.TOKEN)
      SSODecathlonLogout(SSOIdToken, trackEvent, router)
    }
    if (isVirginUser) {
      const SSOIdToken = localStorage.getItem(LOCAL_STORAGE_KEYS.TOKEN)
      SSOVirginLogout(SSOIdToken, trackEvent, router, emptyCart)
    }
    trackEvent({
      category: 'User Information',
      action: `User logged out`,
    })
    deleteUser()
    logoutUser()
    router.push('/register')
  }

  const setModalHowItWorksAndTrack = () => {
    setModalHowItWorks(true)
    trackEvent({
      category: `User Information`,
      action: `Clicked on how it works`,
    })
  }

  const handleDownloadInvoice = async (orderNumber) => {
    const invoicePDF = await getOrderInvoice(orderNumber)
    if (invoicePDF.type === 'GET_ORDER_INVOICE_SUCCESS') {
      if (invoicePDF?.invoice?.url !== undefined) {
        downloadInvoice(invoicePDF?.invoice?.url)
        setInvoiceDownloadError(false)
      }
    }
    if (invoicePDF?.type === 'GET_ORDER_INVOICE_FAILURE') {
      setInvoiceDownloadError(true)
    }
  }

  const { currentContract, allContracts } = useMemo(() => {
    const items =
      contract.items?.sort((a, b) =>
        dayjs(a.startLeasingDate).isAfter(dayjs(b.startLeasingDate)) ? -1 : 1
      ) || []
    return {
      currentContract: items[0],
      allContracts: items,
    }
  }, [contract])

  return user && user.user ? (
    <div className="page-account">
      <Layout
        mainLogo={main?.data?.logo}
        doc={main}
        inStoreText={inStoreText}
        t={t}
        metaTitle={prismicText(
          doc?.data?.meta_title_account,
          t('texts:account:herotitle')
        )}
        metaDescription={doc?.data?.meta_description_account}
        metaKeywords={doc?.data?.meta_keywords_account}
        basket={basket}
        takeback={takeback}
        account={doc}
        faq={faqRes}
        banner={banner}
      >
        {!checkUser ? (
          <section
            className={clsx(
              'account',
              classes.background,
              classes.loaderSection
            )}
          >
            <Loader />
          </section>
        ) : (
          <section className={clsx('account', classes.background)}>
            <Container
              className={classes.accountContainer}
              maxWidth={isSubscription ? 'xl' : 'lg'}
            >
              <div className={classes.accountHeader}>
                <Grid container spacing={4}>
                  <Grid item lg={isSubscription ? 4 : 6} xs={12}>
                    <div className={classes.sticky}>
                      {isMobile && <InfoLink doc={doc} />}
                      <div className={classes.text}>
                        <Typography variant="h3" className={'account__title'}>
                          {prismicText(doc?.data?.hi, t('texts:account:hi'))}{' '}
                          {user?.user?.firstName}
                        </Typography>
                        <Typography
                          variant="body2"
                          color="textSecondary"
                          className={clsx('account_desc', classes.desc)}
                        >
                          <CMSText
                            data={doc?.data?.paragraph1}
                            defaultText={t('texts:account:paragraph1')}
                          />
                        </Typography>
                      </div>
                      {doc?.data?.is_slider_active && (
                        <div className={classes.smallMarginBottom}>
                          <Button
                            size={'small'}
                            variant={'outlined'}
                            color={'primary'}
                            onClick={setModalHowItWorksAndTrack}
                          >
                            <CMSText
                              asText
                              data={doc?.data?.link_name}
                              defaultText={t('texts:account:link_name')}
                            />
                          </Button>
                        </div>
                      )}
                      <Button
                        variant={'contained'}
                        color={'secondary'}
                        size={'small'}
                        onClick={logOut}
                        className={clsx(
                          'account__logout',
                          'btn--logout',
                          classes.smallMarginBottom
                        )}
                      >
                        {prismicText(
                          doc?.data?.log_out_button,
                          t('texts:account:log_out_button')
                        )}
                      </Button>
                      {contract?.items?.length > 0 && (
                        <>
                          {!contract?.loading ? (
                            <div
                              className={clsx(
                                classes.questionContainer,
                                classes.smallMarginBottom
                              )}
                            >
                              <div>
                                {!main.data?.display_flex_price_a_day && (
                                  <Typography
                                    variant={'h4'}
                                    align={'center'}
                                    color={'primary'}
                                  >
                                    <CMSText
                                      asText
                                      data={sub_list?.data?.invoice_this_month}
                                      defaultText={t(
                                        'texts:subscription_order:invoice_this_month'
                                      )}
                                    />
                                    &nbsp;
                                    <b>
                                      {numberToPrice(currentContract?.total)}
                                      {' €'}
                                    </b>
                                  </Typography>
                                )}
                                <Typography
                                  variant={'body2'}
                                  component={'div'}
                                  className={classes.smallMarginBottom}
                                >
                                  <CMSText
                                    data={sub_list?.data?.invoice_explanation}
                                    defaultText={t(
                                      'texts:subscription_order:invoice_explanation'
                                    )}
                                  />
                                </Typography>
                              </div>
                              <div>
                                <Typography
                                  variant={'h5'}
                                  align={'center'}
                                  color={'primary'}
                                  component={'p'}
                                >
                                  <CMSText
                                    asText
                                    data={
                                      sub_list?.data?.subscription_start_date
                                    }
                                    defaultText={t(
                                      'texts:subscription_order:subscription_start_date'
                                    )}
                                  />
                                  &nbsp;
                                  {dayjs(
                                    currentContract?.startLeasingDate
                                  ).format('L')}
                                </Typography>
                                <Typography variant={'body2'} component={'div'}>
                                  <CMSText
                                    data={
                                      sub_list?.data
                                        ?.subscription_date_explanation
                                    }
                                    defaultText={t(
                                      'texts:subscription_order:subscription_date_explanation'
                                    )}
                                  />
                                </Typography>
                              </div>
                            </div>
                          ) : (
                            <div
                              className={clsx(
                                classes.questionContainer,
                                classes.smallMarginBottom,
                                classes.center
                              )}
                            >
                              <Loader />
                            </div>
                          )}
                        </>
                      )}
                      {!isMobile && doc.data?.enable_faq_account && (
                        <AccountFaq doc={doc} />
                      )}
                    </div>
                  </Grid>
                  <Grid item lg={isSubscription ? 8 : 6} xs={12}>
                    {!isMobile && <InfoLink doc={doc} />}
                    {addressUser?.items?.length === 0 && (
                      <div
                        className={clsx(
                          classes.warning,
                          'warning-adress__container'
                        )}
                      >
                        <Warning />
                        <div
                          className={clsx(
                            classes.warningContainer,
                            !isSubscription && classes.warningContainerAlt
                          )}
                        >
                          <Typography>
                            <CMSText
                              data={doc?.data?.warning_text}
                              defaultText={t('texts:account:warning:text')}
                            />
                          </Typography>
                          <div>
                            <Link href="/account/informations">
                              <a>
                                <Button
                                  component={'span'}
                                  size={'small'}
                                  variant={'contained'}
                                  className={classes.warningBtn}
                                >
                                  <CMSText
                                    asText
                                    data={doc?.data?.warning_cta}
                                    defaultText={t('texts:account:warning:cta')}
                                  />
                                </Button>
                              </a>
                            </Link>
                          </div>
                        </div>
                      </div>
                    )}
                    {!userTakeBackProducts?.loading ? (
                      userTakeBackProducts?.response?.variants?.length > 0 && (
                        <TakeBackList
                          t={t}
                          takeback={takeback}
                          userTakeBackProducts={userTakeBackProducts}
                          settings={main?.data}
                        />
                      )
                    ) : (
                      <div className={classes.loaderContainer}>
                        <Loader />
                      </div>
                    )}
                    {!user?.loading ? (
                      isSecondHand &&
                      isSecondHandOnly &&
                      (user?.orders?.length > 0 ? (
                        <TakeBackOrderList
                          t={t}
                          main={main}
                          takeback={takeback}
                          account={doc}
                          stores={stores}
                          orders={user?.orders}
                          postProductToReturn={postProductToReturn}
                          getRightOfWithdrawalInfo={getRightOfWithdrawalInfo}
                          handleDownloadInvoice={handleDownloadInvoice}
                          invoiceDownloadError={invoiceDownloadError}
                        />
                      ) : (
                        <NoOrderBox doc={doc} />
                      ))
                    ) : (
                      <div className={classes.loaderContainer}>
                        <Loader />
                      </div>
                    )}
                    {!isSubscription && !isSecondHand ? (
                      !user?.loading ? (
                        user?.orders?.length > 0 ? (
                          <OrderList
                            doc={doc}
                            orders={user?.orders}
                            t={t}
                            inStoreText={inStoreText}
                            isInStore={parameters?.items?.in_store}
                            showSizes={main?.data?.show_size_name}
                            putUserOrder={putUserOrder}
                            getUserOrders={getUserOrders}
                            takeback={takeback}
                            handleDownloadInvoice={handleDownloadInvoice}
                            invoiceDownloadError={invoiceDownloadError}
                          />
                        ) : (
                          <NoOrderBox doc={doc} />
                        )
                      ) : (
                        <div className={classes.loaderContainer}>
                          <Loader />
                        </div>
                      )
                    ) : !contract?.loading ? (
                      allContracts.length > 0 ? (
                        <>
                          {allContracts.map((item) => (
                            <SubscriptionList
                              key={item.id}
                              postProductToReturn={postProductToReturn}
                              customer_survey={customer_survey}
                              doc={sub_list}
                              prismicAccount={doc?.data}
                              t={t}
                              orders={item.orders}
                              contract={item}
                              settings={main?.data}
                              inStoreText={inStoreText}
                            />
                          ))}
                        </>
                      ) : (
                        !isSecondHand && <NoOrderBox doc={doc} />
                      )
                    ) : (
                      <div className={classes.loaderContainer}>
                        <Loader />
                      </div>
                    )}
                    {!user?.loading && isSecondHand && !isSecondHandOnly && (
                      <SecondHandAndRentalOrderList
                        takeback={takeback}
                        orders={user?.orders}
                        showSizes={main?.data?.show_size_name}
                        putUserOrder={putUserOrder}
                        getUserOrders={getUserOrders}
                        handleDownloadInvoice={handleDownloadInvoice}
                        invoiceDownloadError={invoiceDownloadError}
                        getRightOfWithdrawalInfo={getRightOfWithdrawalInfo}
                        postProductToReturn={postProductToReturn}
                        prismicAccount={doc}
                      />
                    )}
                  </Grid>
                  {isMobile && doc.data?.enable_faq_account && (
                    <Grid item xs={12}>
                      <AccountFaq doc={doc} />
                    </Grid>
                  )}
                </Grid>
              </div>
            </Container>
          </section>
        )}
      </Layout>
      {modalHowItWorks && doc.data.is_slider_active && (
        <SwiperModal
          t={t}
          open={modalHowItWorks}
          handleCloseModal={() => setModalHowItWorks(false)}
          title={prismicText(
            doc?.data?.slides_title,
            t('texts:account:slides_title')
          )}
          slides={doc?.data?.slides}
        />
      )}
      {modalRemoveItem && (
        <SwiperModal
          t={t}
          open={modalRemoveItem}
          handleCloseModal={() => setModalRemoveItem(false)}
          title={prismicText(doc?.data?.slides_title)}
          slides={doc?.data?.slides}
        />
      )}
    </div>
  ) : (
    <section
      className={clsx(
        'account',
        classes.background,
        classes.loaderSection,
        classes.loaderSectionFull
      )}
    >
      <Loader />
    </section>
  )
}

export async function getStaticProps({ locale, previewData }) {
  const client = createClient({ previewData })
  const lang = setFullLocale(locale)
  const takeback = await getSingleDocument(client, lang, 'take_back')
  const general = await getSingleDocument(client, lang, 'general')
  const account: PrismicAccount = await getSingleDocument(
    client,
    lang,
    'account'
  )
  const sub_list = await getSingleDocument(client, lang, 'subscription_order')
  const customer_survey = await getSingleDocument(
    client,
    lang,
    'customer_survey'
  )
  const basket = await getSingleDocument(client, lang, 'basket')
  const funnel = await getSingleDocument(client, lang, 'funnel')
  const inStoreText = await getSingleDocument(client, lang, 'instore')
  const faqRes = await getSingleDocument(client, lang, 'faq')
  const banner = await getSingleDocument(client, lang, 'banner')

  return {
    props: {
      takeback,
      main: general,
      basket,
      funnel,
      doc: account,
      faqRes,
      inStoreText,
      sub_list,
      customer_survey,
      banner,
      i18nResources: await getTranslations(locale, ['texts']),
    },
    revalidate: 300,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Account)
